import { Opacity } from "../../../../base/styles";
import clsx from "clsx";

export const SelectBackgroundOpacity = ({ title, value, className, onChange }:{
    title: string,
    value?: Opacity,
    className?: string,
    onChange: (value?: Opacity) => void,
}) => {
    const handleOnSelectionChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const newValue = e.target.value as Opacity;
        newValue ? onChange(newValue) : onChange(undefined);
    }

    return (
        <div className={clsx(className, "field-group mb-2")}>
            <label className="fs-8 fw-bold text-gray-600">{title}</label>
            <select
                onChange={handleOnSelectionChange}
                value={value || ""}
                className="form-select form-select-sm form-control-xs">
                <option></option>
                <option value={Opacity.Opacity0}>0 %</option>
                <option value={Opacity.Opacity5}>5 %</option>
                <option value={Opacity.Opacity10}>10 %</option>
                <option value={Opacity.Opacity15}>15 %</option>
                <option value={Opacity.Opacity20}>20 %</option>
                <option value={Opacity.Opacity25}>25 %</option>
                <option value={Opacity.Opacity50}>50 %</option>
                <option value={Opacity.Opacity75}>75 %</option>
                <option value={Opacity.Opacity100}>100 %</option>
            </select>
        </div>
    )
}